/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_Platform_FeeInputs */

const en_your_platform_fee = /** @type {(inputs: Your_Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Platform Fee`)
};

const es_your_platform_fee = /** @type {(inputs: Your_Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu comisión de plataforma`)
};

const fr_your_platform_fee = /** @type {(inputs: Your_Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos frais de plateforme`)
};

const de_your_platform_fee = /** @type {(inputs: Your_Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Plattformgebühr`)
};

const ja_your_platform_fee = /** @type {(inputs: Your_Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたのプラットフォーム手数料`)
};

const zh_your_platform_fee = /** @type {(inputs: Your_Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的平台费用`)
};

const ar_your_platform_fee = /** @type {(inputs: Your_Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رسوم المنصة الخاصة بك`)
};

const id_your_platform_fee = /** @type {(inputs: Your_Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya Platform Anda`)
};

const it_your_platform_fee = /** @type {(inputs: Your_Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua commissione di piattaforma`)
};

const ru_your_platform_fee = /** @type {(inputs: Your_Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша комиссия платформы`)
};

const pt_your_platform_fee = /** @type {(inputs: Your_Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua Taxa de Plataforma`)
};

const ko_your_platform_fee = /** @type {(inputs: Your_Platform_FeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`귀하의 플랫폼 수수료`)
};

/**
* | output |
* | --- |
* | "Your Platform Fee" |
*
* @param {Your_Platform_FeeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const your_platform_fee = /** @type {((inputs?: Your_Platform_FeeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_Platform_FeeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_your_platform_fee(inputs)
	if (locale === "es") return es_your_platform_fee(inputs)
	if (locale === "fr") return fr_your_platform_fee(inputs)
	if (locale === "de") return de_your_platform_fee(inputs)
	if (locale === "ja") return ja_your_platform_fee(inputs)
	if (locale === "zh") return zh_your_platform_fee(inputs)
	if (locale === "ar") return ar_your_platform_fee(inputs)
	if (locale === "id") return id_your_platform_fee(inputs)
	if (locale === "it") return it_your_platform_fee(inputs)
	if (locale === "ru") return ru_your_platform_fee(inputs)
	if (locale === "pt") return pt_your_platform_fee(inputs)
	return ko_your_platform_fee(inputs)
});